import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 1C8.993 1 6.555 3.462 6.555 6.5S8.993 12 12 12c3.006 0 5.444-2.462 5.444-5.5S15.006 1 12 1ZM9.666 6.5A2.345 2.345 0 0 1 12 4.143c1.288 0 2.333 1.055 2.333 2.357 0 1.302-1.045 2.357-2.333 2.357A2.345 2.345 0 0 1 9.666 6.5Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.286 12.543a1.545 1.545 0 0 1 2.169-.374A7.778 7.778 0 0 0 12 13.627a7.78 7.78 0 0 0 4.545-1.458 1.545 1.545 0 0 1 2.169.374c.496.708.33 1.689-.37 2.19-1.258.9-2.712 1.54-4.283 1.841l3.705 3.743a1.583 1.583 0 0 1 0 2.223 1.544 1.544 0 0 1-2.2 0L12 18.937 8.433 22.54a1.544 1.544 0 0 1-2.2 0 1.583 1.583 0 0 1 0-2.223l3.706-3.743a10.881 10.881 0 0 1-4.282-1.84 1.582 1.582 0 0 1-.37-2.191Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconSocialOK24 = createIcon(IconComponent);